import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTipoRecurso = '/service/contabilidade/tiporecursovinculado/'

class TipoRecursosVinculadosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTipoRecursosVinculados() {
        return this.conex.get(urlTipoRecurso + 'todos/')
    }
}

export default TipoRecursosVinculadosService
